import { lazy } from 'react';
import { retry } from '../../../../config/utils';

const AccountTopUp = lazy(() => retry(()=> import(/* webpackChunkName: "PartnerUploadLoan" */ "./index")));

export default AccountTopUp;